export default "__VITE_ASSET__97c981a0__"